<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nom et Postnom</span>
      </div>
      <input :value="arbitre.nom"
             name="arbitre_nom"
             disabled
             type="text"
             class="form-control">
      <input :value="arbitre.postnom"
             name="arbitre_postnom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Prénom</span>
      </div>
      <input :value="arbitre.prenom"
             name="arbitre_prenom"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text">Description</span>
      </div>
      <textarea :value="arbitre.description"
                name="arbitre_description"
                disabled
                type="email"
                class="form-control">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date de naissance</span>
      </div>
      <input :value="arbitre.date_naissance"
             name="arbitre_date_naissance"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text">Nationalite</label>
      </div>
      <select name="arbitre_nationalite" disabled class="custom-select">
        <option>{{ arbitre.nationalite }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Age</span>
      </div>
      <input :value="arbitre.age"
             name="arbitre_age"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Nombre des matchs arbitrés</span>
      </div>
      <input :value="arbitre.nombre_matchs_arbitres"
             name="arbitre_nombre_matchs_arbitres"
             disabled
             type="text"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Niveau de l'arbitre</span>
      </div>
      <select v-model="arbitre.niveau"
              disabled
              class="custom-select"
              name="arbitre_niveau">
        <option :value="arbitre.niveau">{{ arbitre.niveau }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de creation</span>
      </div>
      <input :value="arbitre.date_creation"
             name="arbitre_date_creation"
             disabled
             type="date"
             class="form-control">
      <input :value="arbitre.temps_creation"
             name="arbitre_temps_creation"
             disabled
             type="time"
             class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de mise à jour</span>
      </div>
      <input :value="arbitre.date_modification"
             name="arbitre_date_modification"
             disabled
             type="date"
             class="form-control">
      <input :value="arbitre.temps_modification"
             name="arbitre_temps_modification"
             disabled
             type="time"
             class="form-control">
    </div>
  </form>
</template>

<script>
import {mapMutations, mapActions, mapGetters} from 'vuex'

export default {
name: "Read",
  props: {
    arbitre: {
      type: Object
    }
  },
  data(){
    return{
      dataForm: {
        arbitre_id: '',
        nom: '',
        postnom: '',
        prenom: '',
        photo_passeport: '',
        description: '',
        commentaires: '',
        historique: '',
        date_naissance: '',
        age: '',
        nombre_matchs_arbitres: '',
        date_creation: '',
        temps_creation: '',
        date_modification: '',
        temps_modification: '',
        table: 'arbitres',
      }
    }
  },
components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosGetAllData',
    ]),
    onSubmit() {
      this.axiosGetAllData(this.dataForm)
          .then(() => {
          })
          .catch(() => {
          })
    }
  },
  computed: {
    ...mapGetters([
        'getBaseFileURL'
    ])
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/arbitres/components/Read.vue